import React, { Fragment, useEffect, useState } from "react";
import Dashboard from "../Common/Components/Dashboard";
import AdvancedLegendGrid from "./MdcLegendGrid";
import MdcChartWidget from "./MdcChartWidget";
import MdcFilters from "./MdcFilters";
import AddSeries, { Series } from "./AddSeries";
import MdcGridWidget from "./MdcGridWidget";
import ChartOptions from "./MDCChartOptions";
import DashboardOptions from "../Common/Components/DashboardOptions";

const Mdc = () =>{
    const [seriesFromGrid, updateSeriesFromGrid] = useState<any>();
    const [legendSeries, updateLegendSeries] = useState([])

    useEffect(()=>{
        
    },[legendSeries])

    const addSeriesHandler = (object:any) =>{
        updateSeriesFromGrid(object)
    }

    const positionData = 
    [{ col: 1, colSpan: 4, rowSpan: 3 },
    {col:5,colSpan: 2, rowSpan: 3},
    {col:1,colSpan:6,rowSpan:3}]

    const sidebarItems = [
        { title: "Date Range", item: <MdcFilters id="mdc-filters" seriesFromGrid={seriesFromGrid} />, expanded: true },
        { title: "Add Series", item: <AddSeries id="mdc-add-series" seriesFromGrid={seriesFromGrid} />, expanded: true },
        { title: "Chart options", item: <ChartOptions />, expanded: true },
        {title: "Dashboard Options", item: < DashboardOptions />, expanded: true }
    ];

    return (
        <Fragment>
            <Dashboard positionData={positionData} sidebarItems={sidebarItems}>
                <MdcChartWidget id="mdc-chart-widget" header="MDC Chart" legendSeries={legendSeries} updateLegendSeries={updateLegendSeries}/>
                <AdvancedLegendGrid id="mdc-legend-widget" header="Selected Series Grid" legendSeries={legendSeries} updateLegendSeries={updateLegendSeries}/>
                <MdcGridWidget id="mdc-grid-widget" header="Series Grid" addSeries={addSeriesHandler}/>
            </Dashboard>
        </Fragment>
    )
}

export default Mdc;